/**
 * Loads Shopify Search & Discovery complementary products for the latest
 * cart item, then falls back to Shopify's related-product recommendations.
 */
class DroplandCartRecommendations extends HTMLElement {
  #cartUpdateHandler = (event) => {
    const productId = event.detail?.data?.productId;
    if (!productId || String(productId) === this.dataset.primaryProductId) return;

    this.dataset.primaryProductId = String(productId);
    this.#loadRecommendations('complementary');
  };

  connectedCallback() {
    if (this.dataset.loaded === 'true' || !this.dataset.primaryProductId) return;

    this.dataset.loaded = 'true';
    document.addEventListener('cart:update', this.#cartUpdateHandler);
    this.#loadRecommendations('complementary');
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.#cartUpdateHandler);
  }

  async #loadRecommendations(intent) {
    const url = new URL(`${window.Shopify?.routes?.root || '/'}recommendations/products`, window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);
    url.searchParams.set('product_id', this.dataset.primaryProductId);
    url.searchParams.set('intent', intent);

    try {
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const recommendations = html.querySelector('[data-cart-recommendations]');
      const productCount = recommendations?.querySelectorAll('product-card:not([data-placeholder="true"])').length || 0;

      if (productCount > 0) {
        this.innerHTML = recommendations.innerHTML;
        return;
      }

      if (intent === 'complementary') {
        await this.#loadRecommendations('related');
      } else {
        this.hidden = true;
      }
    } catch (error) {
      console.error('Unable to load cart recommendations', error);
      this.hidden = true;
    }
  }
}

if (!customElements.get('dropland-cart-recommendations')) {
  customElements.define('dropland-cart-recommendations', DroplandCartRecommendations);
}
